module.exports = __webpack_public_path__ + "img/autosense-jekyll.firebaseapp.com_en_order_.435be352.png";